import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';

import LanguageModal from './LanguageModal';
import { HeaderButtonWrap } from './styles';

import { ThemeContext } from '@/theme/ThemeProvider';
import { CModal } from "@components/Common";
import PlanetIcon from "../../../components/QBIT/Header/assets/PlanetIcon.svg?react";
import LightPlanetIcon from "../../../components/QBIT/Header/assets/light-PlanetIcon.svg?react";

interface IProps {
  label?: string
  onPress?: () => void
  fontSize?: number
  iconSize?: number
}

const BtnLanguageChange = ({ label, onPress, fontSize, iconSize }: IProps) => {
  const { i18n } = useTranslation()
  const [showModal, setShowModal] = useState(false)
  const closeModal = () => setShowModal && setShowModal(false)
  const openModal = () => {
    setShowModal(true)
  }
  const {  isDarkMode } = useContext(ThemeContext);
  const theme = isDarkMode ? 'dark' : 'light';

  return (
    <HeaderButtonWrap onClick={openModal}>
      <CModal
        visible={showModal}
        onClose={closeModal}
        bgColor={'transparent'}
        isResponsive
      >
        <LanguageModal closeModal={closeModal} />
      </CModal>
      {theme === "light" ?
        <LightPlanetIcon/>
        :
        <PlanetIcon/>
      }
      {/*<IconWorld size={iconSize ? iconSize : 20} />*/}
      {/*<HeaderButtonInner style={fontSize ? { fontSize } : {}}>*/}
      {/*	{i18n.language?.toUpperCase()}*/}
      {/*</HeaderButtonInner>*/}
    </HeaderButtonWrap>
  )
}

export default React.memo(BtnLanguageChange)
